import React from 'react'
import SubmitButton from 'Components/Form/SubmitButton'

export const ButtonWithLabelUnstyled = props => (
  <SubmitButton
    {...props}
    onClick={
      props.onClick || !props.disabled
        ? props.onClickHandler
        : e => e.preventDefault()
    }
  >
    {!props.hideSvg && props.icon}
    <label>{props.label || 'Cancel'}</label>
  </SubmitButton>
)



// WEBPACK FOOTER //
// ./src/Components/Buttons/ButtonWithLabel/unstyled.js